module.exports = __webpack_public_path__ + "img/rev.-dr.-martin-luther-king,-jr..cfdbd1c2.png";